const IDENTIFIERS = {
  GROUP_SCREEN: {
    APP_LOGO: "app-logo",
    GROUP_CODE_INPUT: "group-code-input",
    GROUP_LOCATE_LINK: "group-locate-link",
    LOGIN_SUPPORT_LINK: "login-support-link",
    VERIFY_GROUP_BUTTON: "verify-group-button",
    LOGIN_SUPPORT_CLOSE_BUTTON: "login-support-close-button",
  },
  DISCLAIMER: {
    TITLE: "disclaimer-title",
    DISCLAIMER: "disclaimer",
    TERMS_AND_CONDITIONS: "terms-and-conditions",
    TERMS_AND_CONDITIONS_LINK: "terms-and-conditions-link",
    PRIVACY_POLICY: "privacy-policy",
    PRIVACY_POLICY_LINK: "privacy-policy-link",
    AGREE_BUTTON: "agree-button",
  },

  NAVIGATION: {
    WEBVIEW_BACK_BUTTON: "webview-back-button",
  },
  LOGIN: {
    USERNAME_INPUT: "username-input",
    PASSWORD_INPUT: "password-input",
    LOGIN_BUTTON: "login-button",
    REMEMBER_ME_CHECKBOX: "remember-me-checkbox",
    FORGOT_PASSWORD_LINK: "forgot-password-link",
    REGISTER_BUTTON: "register-button",
    NEED_HELP_LINK: "need-help-link",
    // BIOMETRIC_AUTHENTICATION_BUTTON: "biometric-authentication-button",
  },
  ACCOUNT_RESET: {
    FORGET_PASSWORD_TAB: "forget-password-tab",
    FORGET_USERNAME_TAB: "forget-username-tab",
    USERNAME_INPUT: "username-input",
    EMAIL_INPUT: "email-input",
    // FORGOT_PASSWORD_BUTTON: "forgot-password-button",
    // FORGOT_USERNAME_BUTTON: "forgot-username-button",
    FORGOT_PASSWORD_VERIFY_BUTTON: "forgot-password-verify-button",
    FORGOT_USERNAME_VERIFY_BUTTON: "forgot-username-verify-button",
    BACK_BUTTON: "account-reset-back-button",
  },
  VERIFICATION: {
    BACK_BUTTON: "verification-back-button",
    OTP_INPUT: "verification-otp-input",
    RESEND_OTP_BUTTON: "verification-resend-otp",
    NEW_PASSWORD_INPUT: "verification-new-password",
    CONFIRM_NEW_PASSWORD_INPUT: "verification-confirm-new-password",
    CONFIRM_BUTTON: "verification-confirm-button",
  },
  REGISTER: {
    BACK_BUTTON: "register-back-button",
    GROUP_CODE_INPUT: "register-group-code-input",
    USERNAME_INPUT: "register-username-input",
    PASSWORD_INPUT: "register-password-input",
    CONFIRM_PASSWORD_INPUT: "register-confirm-password-input",
    FIRST_NAME_INPUT: "register-firstname-input",
    LAST_NAME_INPUT: "register-lastname-input",
    DOB_INPUT: "register-dob-input",
    ZIP_CODE_INPUT: "register-zip-code-input",
    EMAIL_INPUT: "register-email-input",
    PHONE_NUMBER_INPUT: "register-phone-number-input",
    EMPLOYEE_ID_RADIO_BUTTTON: "register-employee-id-radio-button",
    EMPLOYEE_ID_INPUT: "register-employee-id-inputt",
    SSN_RADIO_BUTTON: "register-ssn-radio-button",
    SSN_INPUT: "register-ssn-input",
    SUBMIT_BUTTON: "register-submit-button",
    DISCLAIMER_AGREE_BUTTON: "register-disclaimer-agree-button",
    DISCLAIMER_BACK_BUTTON: "register-disclaimer-back-button",
  },
  REGISTER_VERIFY_OTP: {
    OTP_INPUT: "register-verify-otp-input",
    RESEND_OTP: "register-verify-resend-otp",
    SUBMIT: "register-verify-submit",
  },
  GROUP_INFO: {
    CHANGE_GROUP_BUTTON: "group-info-change-group-button",
    CALL_NOW_BUTTON: "group-info-call-now-button",
    MESSAGE_SUPPORT_BUTTON: "group-info-message-support-button",
    SERVICE_PROVIDER_WEBSITE_LINK: "group-info-service-provider-website-link",
    SERVICE_PROVIDER_SUPPORT_NUMBER:
      "group-info-service-provider-support-number",
    SERVICE_PROVIDER_EMAIL_LINK: "group-info-service-provider-email-link",
    CLOSE_BUTTON: "group-info-close-button",
  },
  MESSAGE_SUPPORT: {
    NAME_INPUT: "message-support-name-input",
    EMAIL_INPUT: "message-support-email-input",
    MESSAGE_INPUT: "message-support-message-input",
    SEND_MESSAGE_BUTTON: "message-support-send-message-button",
    CLOSE_BUTTON: "message-support-close-button",
  },
  ID_CARD: {
    REQUEST_NEW_ID_CARD_BUTTON: "request-new-id-card-button",
    DOWNLOAD_ID_CARD_BUTTON: "download-id-card-button",
    SUBMIT_REQUEST_NEW_ID_CARD_BUTTON: "submit-request-new-id-card-button",
  },

  BIOMETRICS: {
    CURRENT_SETTING_STATUS: "current-setting-status",
    ENABLE_BIOMETRICS_BUTTON: "enable-biometrics-button",
    DISABLE_BIOMETRICS_BUTTON: "disable-biometrics-button",
  },
  MFA_LOGIN: {
    VERIFY_OTP_BUTTON: "mfa-login-verify-otp-button",
    RESEND_OTP_BUTTON: "mfa-login-resend-otp-button",
  },
  MFA_DISABLE: {
    CROSS_BUTTON: "mfa-disable-cross-button",
    PASSWORD_INPUT: "mfa-disable-password-input",
    SUBMIT_BUTTON: "mfa-disable-submit-button",
    MODAL_CLOSE_BUTTON: "mfa-disable-modal-close-button",
    MODAL_CANCEL_BUTTON: "mfa-disable-modal-cancel-button",
    MODAL_OK_BUTTON: "mfa-disable-modal-ok-button",
  },
  MFA_ENABLE: {
    CROSS_BUTTON: "mfa-enable-cross-button",
    ENABLE_BUTTON: "mfa-enable-button",
  },
  MFA_SETUP_SEND_OTP: {
    CROSS_BUTTON: "mfa-setup-send-otp-cross-button",
    REQUEST_OTP_BUTTON: "mfa-setup-send-otp-request-otp-button",
  },
  MFA_SETUP_VERIFY_OTP: {
    CROSS_BUTTON: "mfa-setup-verify-otp-cross-button",
    VERIFY_OTP_BUTTON: "mfa-setup-verify-otp-verify-otp-button",
    RESEND_OTP_BUTTON: "mfa-setup-verify-otp-resend-otp-button",
  },
  MFA_SUCCESS: {
    CROSS_BUTTON: "mfa-success-cross-button",
    FINISH_BUTTON: "mfa-success-finish-button",
  },
  MFA_SETUP_ADD_EMAIL: {
    CROSS_BUTTON: "mfa-setup-add-email-cross-button",
    USE_EMAIL_BUTTON: "mfa-setup-add-email-use-email-button",
    EMAIL_INPUT: "mfa-setup-add-email-email-input",
  },
  VIDEOS: {
    VIDEO_ITEM: "video-item",
  },
  CARE_AND_CLAIMS_HISTORY: {
    CLAIM_ITEM: "claim-item",
    VISIT_DETAILS: "visit-details",
    VISIT_DETAILS_CLOSE_BUTTON: "visit-details-close-button",
    VIEW_EOB_BUTTON: "view-eob-button",
    APPEAL_CLAIM_BUTTON: "appeal-claim-button",
    PAYOUT_OF_FLEX_BUTTON: "pay-out-of-flex-button",
    DOWNLOAD_CLAIMS_BUTTON: "download-claims-button",
  },

  PROFILE: {
    ID_CARD: "profile-id-card",
    MY_BENEFIT: "profile-my-benefit",
    MANAGE_EOB: "profile-manage-eob",
    UPDATE_MFA: "profile-update-mfa",
    OTHER_MEMBERS: "profile-other-members",
    MY_ACCOUNT: "profile-my-account",
    CHANGE_PASSWORD: "profile-change-password",
    MY_PCP: "profile-my-pcp",
    INVITE_USER: "profile-invite-user",
    LOG_OUT: "profile-log-out",
  },

  DATA_ACCESS_MANAGEMENT: {
    ACTION_BUTTON: "data-access-management-action-button",
  },

  ACCESS_GRANT_DISCLAIMER: {
    AGREE_BUTTON: "access-grant-disclaimer-agree-button",
    CANCEL_BUTTON: "access-grant-disclaimer-cancel-button",
  },
  ACCESS_REVOKE_DISCLAIMER: {
    REVERT_BUTTON: "access-revoke-disclaimer-revert-button",
    CANCEL_BUTTON: "access-revoke-disclaimer-cancel-button",
  },
  ACCESS_CONSENT_DISCLAIMER: {
    ACCEPT_BUTTON: "access-consent-disclaimer-accept-button",
    DECLINE_BUTTON: "access-consent-disclaimer-decline-button",
  },
  ACCESS_ACCEPT_DISCLAIMER: {
    ACKNOWLEDGE_BUTTON: "access-accept-disclaimer-ok-button",
  },
  ACCESS_DECLINE_DISCLAIMER: {
    ACKNOWLEDGE_BUTTON: "access-decline-disclaimer-ok-button",
  },
  RIGHT_SIDEBAR: {
    CLOSE_BUTTON: "right-sidebar-close-button",
  },
  PAPERLESS_EOB: {
    CONFIRM_BUTTON: "paperless-eob-go-paperless-button",
    DISMISS_BUTTON: "paperless-eob-remid-me-later-button",
    DONOT_ASK_AGAIN_BUTTON: "paperless-eob-donot-ask-again-button",
    ACKNOWLEDGE_BUTTON: "paperless-eob-acknowledge-button",
  },
  MANAGE_EOB: {
    SAVE_BUTTON: "manage-eob-save-button",
    CANCEL_BUTTON: "manage-eob-cancel-button",
    ACKNOWLEDGE_BUTTON: "manage-eob-acknowledge-button",
  },
  VIEW_EOB: {
    ACKNOWLEDGE_BUTTON: "view-eob-acknowledge-button",
  },
  INVITE_USER: {
    WIDGET_INVITE_BUTTON: "widget-invite-button",
    CROSS_BUTTON: "invite-user-cross-button",
    INVITE_BUTTON: "invite-user-invite-button",
    CANCEL_BUTTON: "invite-user-cancel-button",
    TRY_AGAIN_BUTTON: "invite-user-try-again-button",
    ACKNOWLEDGE_BUTTON: "invite-user-acknowledge-button",
  },
  RETURN_LOGIN_BUTTON: "return-to-login-button",
} as const;

export default IDENTIFIERS;
